import _wrap from "lodash/wrap";
let popState = false;

if (typeof window !== 'undefined') {
  window.addEventListener('popstate', () => {
    popState = true;
  });
  history.pushState = _wrap(history.pushState, (pushState, ...args) => {
    popState = false;
    pushState.apply(history, args);
  });
}

const isHistoryEntryFromPopState = () => popState;

export default isHistoryEntryFromPopState;